module.exports = __webpack_public_path__ + "img/enable-0.5a716424.jpg";